import { Fragment } from "react";
import { Mui } from "@osu/react-ui";
import { dropdownSubtypes, inputMappings } from "../../util/enums";
import { GRAD_SCHOOL_PETITIONS_EMAIL } from "../../util/constants";

export const formSections = [
  {
    id: "late-course-petition",
    title: "Late Course Petition",
    questions: [
      {
        id: "effective-term",
        title: "Effective Term",
        type: inputMappings.dropDown,
        subtype: dropdownSubtypes.term,
        dataField: 'termCode',
        filter: {
          showFromPresent: 1,
          showHistorical: 4
        }
      },
      {
        id: "advisor-info",
        type: inputMappings.dropDown,
        title: "Advisor",
        dataField: "advisor",
        subtype: dropdownSubtypes.advisor,
        required: false
      },
      {
        id: 'late-course-petition-type',
        type: inputMappings.radio,
        title: 'Late Course Petition Type',
        dataField: "courseType",
        required: true,
        choices: [
          {
            id: 'add-course',
            value: "ADD",
            title: 'Add Course'
          },
          {
            id: "change-audit-to-grade",
            value: "AUDIT_TO_GRADE",
            title: "Change Audit Course to Grade Course",
          },
          {
            id: "change-grade-to-audit",
            value: "GRADE_TO_AUDIT",
            title: "Change Grade Course to Audit Course",
          },
          {
            id: "drop-course",
            value: "DROP",
            title: "Drop Course",
            branch: "last-date-attend"
          }
        ]
      },
      {
        id: "last-date-attend",
        title: "Drop Date Last Attend",
        summary: "Please enter the last date this course was last attended",
        dataField: 'lastAttendDate',
        hidden: true,
        type: inputMappings.date,
        required: false,
        dependencies: ["late-course-petition-type"]
      },
      {
        id: "courses-input-group",
        title: "Courses",
        dataField: 'courses',
        type: inputMappings.inputGroup,
        numberOfResponsesMinimum: 1,
        numberOfResponsesMaximum: 1,
        questions: [
          {
            id: "courses-ig-number",
            type: inputMappings.textInput,
            title: "Course Number",
            dataField: 'courseNumber',
            summary: null,
            required: true,
          },
          {
            id: "class-number",
            type: inputMappings.textInput,
            title: "Class Number",
            dataField: 'classNumber',
            summary: null,
            required: true,
          },
          {
            id: "subject",
            type: inputMappings.textInput,
            dataField: 'courseSubject',
            title: "Course Subject",
            summary: null,
            required: true,
          },
          {
            id: "credit-hours",
            type: inputMappings.textInput,
            dataField: 'creditHours',
            title: "Credit Hours",
            summary: null,
            required: true,
          },
          {
            id: "instructor-name-n",
            type: inputMappings.textInput,
            dataField: 'instructor',
            title: "Instructor name.#",
            summary: null,
            required: true
          },
          {
            id: "reason",
            type: inputMappings.textInput,
            dataField: 'reason',
            title: "Reason",
            summary: "(250 character limit)",
            rows: 5,
            required: true,
            multiline: true,
            gridProps: {
              xs: 12,
              md: 12,
            },
            inputProps: {
              maxLength: 250
            }
          }
        ],
        options: {
          viewAsTable: true,
        }
      },
      {
        id: "file-upload",
        type: inputMappings.fileUpload,
        title: "Attachment(s)",
        Description: () => (
          <Fragment>
            <Mui.Typography variant="body2">
              Attach relevant supporting documents (excluding medical records, which must be emailed to <a href={`mailto:${GRAD_SCHOOL_PETITIONS_EMAIL}`}>{GRAD_SCHOOL_PETITIONS_EMAIL}</a>).
            </Mui.Typography>
            <Mui.Typography variant="body2" className="margin-bottom-1">
              (Supported file types: Text, PDF, Microsoft Word, Microsoft Excel, and images with extensions bmp, gif, jpeg, png and tiff)
            </Mui.Typography>
          </Fragment>
        ),
        required: false,
        dataField: "attachments",
        acceptedFileTypes: ["application/msword", ".doc", ".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ".xls", ".xlsx", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "image/gif", ".gif",
          "image/png", ".png", "image/jpeg", ".jpeg", "image/bmp", ".bmp", "image/tiff", ".tiff", "text/plain", "application/pdf", ".txt"
        ],
        maxFileCount: 5,
        maxFileSize: 20000000 // 20MB
      }
    ]
  },
  {
    title: "Petition Disclaimer",
    id: "petition-disclaimer",
    Component: () => (
      <Mui.Typography>
        Please be advised that any information submitted in this petition that involves allegations of discrimination, harassment, or other 
        potential violations of civil rights will be referred to the Office of Civil Rights as Graduate School staff are mandatory reporters.
      </Mui.Typography>
    )
  }
];

export const gradSchoolPreApprovalQuestions = [
  {
    id: "approvers",
    type: inputMappings.inputGroup,
    title: "Approvers",
    subtitle: "OSU Employees",
    required: true,
    numberOfResponsesMinimum: 1,
    numberOfResponsesMaximum: 5,
    dataField: "approvers",
    deleteAll: true,
    questions: [
      {
        id: "approver-info",
        type: inputMappings.approverLookup,
        title: "OSU Employee"
      }
    ]
  }
];

export const lastDateAttendApprovalQuestion = {
  id: "last-date-attend",
  title: "Drop Date Last Attend",
  summary: "Please enter the last date this course was last attended",
  dataField: 'lastAttendDate',
  type: inputMappings.date,
  required: true,
  summaryProps: {
    fontWeight: "fontWeightBold"
  }
}